module.exports = __webpack_public_path__ + "media/images/new-ui-images/blue-calendar-0834fa7a57a83737d9bf36a21218ef7d.svg";